import { client } from "utils";

export const platformsRequest = () => client.get("platforms");
